import React from 'react';
import { Check } from 'lucide-react';
import { Button } from '../ui/Button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { cn } from '../../lib/utils';
export interface PricingCardsProps {
  ctaLabel?: string;
  onSelect?: (planId: string) => void;
  selectedPlan?: string;
}
const plans = [{
  id: 'starter',
  name: 'Starter',
  price: '99',
  description: 'Para oficinas pequenas começando',
  features: ['Até 50 OS/mês', '1 usuário', 'Suporte por email'],
  popular: false
}, {
  id: 'pro',
  name: 'Pro',
  price: '249',
  description: 'Mais popular',
  features: ['OS ilimitadas', 'Até 5 usuários', 'Controle de estoque completo', 'Suporte prioritário'],
  popular: true
}, {
  id: 'business',
  name: 'Business',
  price: '499',
  description: 'Para múltiplas oficinas',
  features: ['Tudo do Pro + multi-loja', 'Usuários ilimitados', 'API + integrações', 'Gestor de sucesso dedicado'],
  popular: false
}];
export function PricingCards({
  ctaLabel = 'Selecionar',
  onSelect,
  selectedPlan
}: PricingCardsProps) {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-91">
      {plans.map(plan => {
      const isSelected = selectedPlan === plan.id;
      return <Card key={plan.id} className={cn('relative flex flex-col transition-all duration-200', plan.popular ? 'border-primary shadow-lg shadow-primary/10' : 'border-border', isSelected ? 'ring-2 ring-primary border-primary' : 'hover:border-primary/50', 'cursor-pointer')} onClick={() => onSelect?.(plan.id)} data-id="element-92">
            {plan.popular && <div className="absolute -top-3 left-0 right-0 flex justify-center" data-id="element-93">
                <Badge className="bg-primary text-primary-foreground hover:bg-primary font-medium px-3 py-0.5" data-id="element-94">
                  Mais popular
                </Badge>
              </div>}
            <CardHeader data-id="element-95">
              <CardTitle className="text-xl" data-id="element-96">{plan.name}</CardTitle>
              <CardDescription data-id="element-97">{plan.description}</CardDescription>
            </CardHeader>
            <CardContent className="flex-1" data-id="element-98">
              <div className="mb-6 flex items-baseline text-foreground" data-id="element-99">
                <span className="text-4xl font-bold font-heading" data-id="element-100">
                  R$ {plan.price}
                </span>
                <span className="text-muted-foreground ml-1 font-medium" data-id="element-101">
                  /mês
                </span>
              </div>
              <ul className="space-y-3 text-sm" data-id="element-102">
                {plan.features.map((feature, i) => <li key={i} className="flex items-center gap-3" data-id="element-103">
                    <Check className="h-4 w-4 text-primary shrink-0" data-id="element-104" />
                    <span className="text-muted-foreground" data-id="element-105">{feature}</span>
                  </li>)}
              </ul>
            </CardContent>
            <CardFooter data-id="element-106">
              <Button className="w-full" variant={isSelected || plan.popular ? 'default' : 'outline'} onClick={e => {
            e.stopPropagation();
            onSelect?.(plan.id);
          }} data-id="element-107">
                {ctaLabel}
              </Button>
            </CardFooter>
          </Card>;
    })}
    </div>;
}